import { Col, Form } from 'react-bootstrap'

import CheckBoxComponent from '../../../../../../componentsV2/DataEntryComponents/CheckBox/CheckBox'
import CheckBoxComponent2 from '../../../../../../componentsV2/DataEntryComponents/CheckBox/Checkbox2'

const FormColumnOne = ({
    adavnceFilterFormVal,
    checkBoxSelectOptions,
    dmode,
    dir,
    t,
    setAdavnceFilterFormVal,
    setCheckBoxSelectOptions
}) => {

    const handleCheckboxChange = (name, event) => {
        if (
            (name === 'archivedProduct' && event === false) ||
            (name === 'blockedProduct' && event === false)
        ) {
            setCheckBoxSelectOptions('')
        } else {
            setCheckBoxSelectOptions(name)
        }
    }

    const formValuesOnChangeFunc = (value, fieldName) => {
        setAdavnceFilterFormVal((prevState) => ({
            ...prevState,
            [fieldName]: value,
        }))
    }

    return (
        <>
            <Col sm={12} md={12} lg={4} dir={dir}>
                <h6
                    dir={dir}
                    className={`ad-filter-sub-header ${dmode && 'head-dark'}`}
                >
                    {t('product')}
                </h6>
                <Form.Group className="mb-2" dir={dir}>
                    <Form.Label className="glo-label" dir={dir}>
                        {t('name')} / {t('barcode')}
                    </Form.Label>
                    <Form.Control
                        value={adavnceFilterFormVal.productOrBarcode}
                        name="productOrBarcode"
                        type="text"
                        placeholder={t('PLANOGRAM_THAT_CONTAIN')}
                        className={`input-field ${dmode && 'input-field-dark'}`}
                        onChange={(e) =>
                            formValuesOnChangeFunc(
                                e.target.value,
                                e.target.name
                            )
                        }
                        dir={dir}
                    />
                </Form.Group>
                <Form.Group className={'mt-4 copy-arrangement-checkbox'}>
                    <CheckBoxComponent
                        dmode={dmode}
                        dir={dir}
                        label={t('CONTAINED_ARCHIVED_PRODUCTS')}
                        name="archivedProduct"
                        setCheckBoxStatus={handleCheckboxChange}
                        value={checkBoxSelectOptions}
                    />
                    <CheckBoxComponent2
                        dmode={dmode}
                        dir={dir}
                        label={t('CONTAINED_BLOCKED_SALES_PRODUCTS')}
                        name="blockedProduct"
                        setCheckBoxStatus={handleCheckboxChange}
                        value={checkBoxSelectOptions}
                    />
                </Form.Group>
            </Col>
        </>
    )
}

export default FormColumnOne
